import axiosInstance from '../common/axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;
/*
export async function fetchFilteredProducts(filters) {
     return axiosInstance.post(`${backendUrl}/api/products/filter`, filters);
    }
*/

export async function fetchFilteredProducts(filters, page, size) {
     
     // 1. Define the payload (request body)
    const payload = filters; 

    // 2. Define the pagination parameters (for the query string)
    const params = {
        page: page,
        size: size
    };
     
     return axiosInstance.post(`${backendUrl}/api/products/filter`, payload, {
            params: params, // Sends page and size as ?page=X&size=Y
        });
    }





export async function fetchSupplierProducts(id, data) {
     if(id){
          return axiosInstance.post(`${backendUrl}/api/products/all/suppliers/${id}`, data);
     }else{
          return axiosInstance.post(`${backendUrl}/api/products/all/suppliers`, data);
     }
     
    }

